import { lazy } from "react";
import { getTenant } from "../../../Utils/storageUtils";
import { TenantType } from '../../../Utils/types';
import { isCommonTenant } from '../../CommonTenant/utils/configUtils';

const PBNudgesScreenDashboard = lazy(()=> import('../../PaisaBazaar/NudgesScreenDashboard'));
const CommonTenantNudgesScreenDashboard = lazy(()=> import('../../CommonTenant/NudgesScreenDashboard'));
const AUNudgesScreenDashboard = lazy(()=> import('../../AUBank/NudgesScreenDashboard'));

const NudgesScreenDashboard = ()=>{
    const renderTenantSpecificDashboard = () => {
        if (isCommonTenant()) {
          return <CommonTenantNudgesScreenDashboard />;
        }
        switch (getTenant()) {
          case TenantType.PB:
            return <PBNudgesScreenDashboard/>
          case TenantType.AU:
              return <AUNudgesScreenDashboard/>
          case TenantType.JFS:
          case TenantType.YESBANK:
          case TenantType.MAHINDRA:
          default:
            return <></>;
        }
      };
    return(
        <div>
           {renderTenantSpecificDashboard()}
        </div>
    )
}

export default NudgesScreenDashboard;